// Navigation & Logo
(function($, undef){

  var setLogoColor = function(){
    var active = $('header#hero section.active');
    if(!active.length){
      active = $('header#hero section').first();
    }

    if(active.hasClass('light')){
      $('.header-logo').addClass('white');
    }
  };

  $(document).ready(function(){
    setLogoColor();
  });

  // Setup faux hover for non-touch devices.
  $(document).one('mousemove', function(){
    $('.nav-bar').on('mouseenter mouseleave', function(e){
      if(e.type == "mouseenter"){
        $(this).addClass('active');
      }else if(!$(this).find('.input-group-field:focus').length){
        $(this).removeClass('active');
      }
    });
  });
}(jQuery));

// Header parallax
(function($, undef){
  var img = $('#hero .bg'),
      scrollFactor = 0.8, // 80% of actual scroll.
      lastPosition = 0,
      positioning = 'fixed',
      adjustment = $('#hero').offset().top,
      animationId;

  var styleBG = function(){
    var padding = img.parents('#hero').css("paddingTop");
    img.css({
      position: positioning,
      height: 0,
      paddingTop: padding
    });
    img.css('paddingTop', "+="+adjustment.toString()+"px");
  };

  var moveHero = function(){
    if(window.pageYOffset != lastPosition){
      lastPosition = window.pageYOffset;
      var pos = -(lastPosition * (1-scrollFactor)).toFixed(2);
      img.css({transform: 'translate3d(0,'+pos+'px,0)'});
    }

    animationId = requestAnimationFrame(moveHero);
  };

  // Cancel our parallax if we get a touch event, as those don't play well.
  $(window).on('touchstart msgesturechange', function(){
    cancelAnimationFrame(animationId);
    positioning = 'absolute';
    img.css({
      position: positioning,
      transform: "none"
    });
  });

  $(window).resize(styleBG).trigger('resize');
  animationId = requestAnimationFrame(moveHero);
}(jQuery));

// Out of stock signup
(function($, undef){
  $('#out-of-stock-signup').submit(function(e){
    var form = $(this);
    e.preventDefault();
    $.getJSON(
    this.action + "?callback=?",
    form.serialize(),
    function (data) {
      if (data.Status === 400) {
        form.find('.note').attr('class', 'note errors').html(data.Message);
      } else { // 200
        form[0].reset();
        form.find('[type=email]')[0].blur();
        form.find('.note').attr('class', 'note success').html("Thanks for signing up. We'll be in touch if we have any news to share related to this product.");
      }
    });
  });
}(jQuery));
